"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Icon", {
    enumerable: true,
    get: function() {
        return Icon;
    }
});
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const Icon = (param)=>{
    let { name, humanName, className = "", fontSize, size = "md", color } = param;
    const finalSize = fontSize != null ? fontSize : size === "sm" ? "16px" : null;
    return /*#__PURE__*/ _react.default.createElement("span", {
        title: humanName !== null && humanName !== void 0 ? humanName : undefined,
        className: "material-symbols-outlined ".concat(className),
        style: {
            fontSize: finalSize !== null && finalSize !== void 0 ? finalSize : undefined,
            color: color !== null && color !== void 0 ? color : undefined
        }
    }, name);
};

//# sourceMappingURL=Icon.js.map